import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { CoreAngularProxyModule } from '@medrio/core-angular-proxy';
import { CharCounterPipe } from './pipes/char-counter.pipe';
import { MedTooltipDisabledDirective } from './directives/tooltip-disable/tooltip-disable.directive';

@NgModule({
  declarations: [CharCounterPipe, MedTooltipDisabledDirective],
  imports: [],
  exports: [
    CommonModule,
    FlexLayoutModule,
    TranslateModule,
    CoreAngularProxyModule,
    CharCounterPipe,
    MedTooltipDisabledDirective,
  ],
})
export class MedrioCrossStudyPortalModule { }
